export default "__VITE_ASSET__CEEOG1V9__"